import InfoModal from '@/components/molecules/InfoModal';
import ACCreationForm from '@/components/organisms/ACCreationForm';
import { setBreadcrumbs } from '@/store/slices/breadcrumb';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { accountingCenterService } from '@/services/accounting-centers.service';
import toast from 'react-hot-toast';

function formatACType(acType: string) {
  return acType
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const ACEditPage = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [accountingCenter, setAccountingCenter] = useState<any>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { budgetId, acType, acId } = useParams();
  const location = useLocation();

  const acCenter = location.state?.acCenter as any | undefined;

  useEffect(() => {
    // Set breadcrumbs when component mounts
    dispatch(
      setBreadcrumbs([
        {
          title: 'Budget',
          path: `/budgets/${budgetId}`
        },
        {
          title: acCenter?.name ? acCenter?.name + ' Overview' : ' Accounting Center Overview',
          path: `/budgets/${budgetId}/accounting-centers/${acType}`
        },
        {
          title: acCenter?.name ? acCenter?.name + '' : ' Accounting Center',
          path: `/budgets/${budgetId}/accounting-centers/${acType}/${acId}`
        },
        {
          title: 'Edit',
          path: ``
        }
      ])
    );
  }, []);

  useEffect(() => {
    getAccountingCenter();
  }, []);

  const getAccountingCenter = async () => {
    try {
      const { data: acData } = await accountingCenterService.getAccountingCenter(budgetId || '', acId || '');

      setAccountingCenter(acData);
    } catch (error) {
      console.error('Error getting accounting center:', error);
    }
  };

  const handleSubmit = async (data: any) => {
    console.log('Submit', data);
    try {
      if (!budgetId) {
        throw new Error('BudgetId is required');
      }
      const response = await accountingCenterService.updateAccountingCenter(budgetId, acId || '', {
        ...data,
        type: acType?.toUpperCase()
      });
      console.log('Response', response);
      toast.success('Accounting center updated successfully');
      navigate(-1);
    } catch (error) {
      console.error('Error creating accounting center:', error);
    }
  };

  return (
    <>
      <div className=" bg-[#FBFBFF] p-4 flex flex-col flex-1 md:bg-white rounded-[16px] border">
        <h2 className="text-center font-semibold mb-5 md:text-left md:text-[24px] md:mb-6">
          Edit your Department Accounting Center
        </h2>

        {/* FORM */}
        <ACCreationForm
          onSubmit={handleSubmit}
          defaultValues={{
            name: accountingCenter?.name,
            description: accountingCenter?.description,
            acmev: accountingCenter?.acmev,
            acmev_alert_threshold: accountingCenter?.acmev_alert_threshold,
            acrt: accountingCenter?.acrt,
            acrt_alert_threshold: accountingCenter?.acrt_alert_threshold
          }}
          isEditMode={true}
        />
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <InfoModal
          isOpen={showSuccessModal}
          variant="success"
          title="Bank Account Created"
          message={<p>You have successfully created a Bank Account!</p>}
          buttonText="Go to Bank Account"
          onButtonClick={() => {}}
        />
      )}
    </>
  );
};

export default ACEditPage;
